

import * as React from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { Tooltip } from 'antd';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { PDFExport } from '@progress/kendo-react-pdf';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { PrivateAxios, url } from '../../../environment/AxiosInstance';
import { isURL } from '../../../environment/Helper';
import { UserAuth } from '../../auth/Auth';
import { SuccessMessage } from '../../../environment/ToastMessage';
import EditTaskModal from './EditTaskModal';
import DeleteTaskModal from './DeleteTaskModal';
import CreateTaskModal from './AddTaskModal';

// Import your Close and Done modals
import CloseTaskModal from './CloseTaskModal';
import DoneTaskModal from './ProjectTaskDoneModal';
import ViewProjectTaskModal from './ViewProjectTaskModal';
import ProjectMessage from '../../../component/ProjectMessage';

// Export Refs
const excelExportRef = React.createRef();
const pdfExportRef = React.createRef();

// --- Cells ---
const SerialNumberCell = (props) => <td>{props.dataIndex + 1}</td>;

const ProjectTaskNameCell = (props) => (
    <td><p className="text-dark fw-bold mb-0">{props.dataItem.task_name}</p></td>
);
const ProjectNameCell = (props) => (
    <td><p className="text-dark fw-bold mb-0">{props?.dataItem?.project?.project_name}</p></td>
);
const DoerNameCell = (props, users) => {
    let heads = props.dataItem.assigned_to;

    if (typeof heads === "string") {
        try {
            heads = JSON.parse(heads);
        } catch {
            heads = [];
        }
    }
    if (!Array.isArray(heads)) heads = heads ? [heads] : [];

    return (
        <td>
            <div className="d-flex align-items-center flex-wrap multi-profile">
                {heads.length > 0 ? (
                    heads.map((headId, index) => {
                        const user = users.find((u) => u.id === headId);

                        return (
                            <div className="profile-wrap" key={index}>
                                <Tooltip title={user ? user.name : `ID: ${headId}`} placement="top">
                                    <div className="exp-avtar bg-exp-yellow">
                                        {user?.user_photo != null ? (
                                            <img
                                                className="prof-img"
                                                src={isURL(user?.user_photo) ? user.user_photo : url + user.user_photo}
                                                alt="user"
                                            />
                                        ) : (
                                            <span>
                                                {user?.name
                                                    ? user.name.split(' ').length > 1
                                                        ? user.name.split(' ')[0][0] + user.name.split(' ')[1][0]
                                                        : user.name.slice(0, 2)
                                                    : ''}
                                            </span>
                                        )}
                                    </div>
                                </Tooltip>
                            </div>
                        );
                    })
                ) : (
                    <span className="text-muted">N/A</span>
                )}
            </div>
        </td>
    );
};
// const DoerNameCell = (props, User) => (
//   <td>
//     {User && User.map((item) =>
//       item.id === props.dataItem.assigned_to ? (
//         <div className="profile-wrap" key={item.id}>
//           <div className="exp-avtar bg-exp-yellow">
//             {item.user_photo ? (
//               <img className="prof-img" src={isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" />
//             ) : (
//               <span>{item.name ? item.name.split(' ').map(n => n[0]).join('') : ""}</span>
//             )}
//           </div>
//           <div className="ps-2 profile-name-wrap text-truncate">
//             <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
//           </div>
//         </div>
//       ) : ""
//     )}
//   </td>
// );

const PriorityCell = (props) => {
    const priority = props.dataItem.priority?.toLowerCase();
    const priorityClass = `priority-set ${priority === 'high' ? 'high1' : priority === 'medium' ? 'medium' : 'low'}`;
    return (
        <td>
            <div className={priorityClass}>
                <i className="fas fa-flag mr-2" />
                <span>{props.dataItem.priority.charAt(0).toUpperCase() + props.dataItem.priority.slice(1)}</span>
            </div>
        </td>
    );
};

const AssignByCell = (props, User) => (
    <td>
        {User && User.map((item) =>
            item.id === props.dataItem.assigned_by ? (
                <div className="profile-wrap" key={item.id}>
                    <div className="exp-avtar bg-exp-yellow">
                        {item.user_photo ? (
                            <img className="prof-img" src={isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" />
                        ) : (
                            <span>{item.name ? item.name.split(' ').map(n => n[0]).join('') : ""}</span>
                        )}
                    </div>
                    <div className="ps-2 profile-name-wrap text-truncate">
                        <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
                    </div>
                </div>
            ) : ""
        )}
    </td>
);

const StartDateCell = (props) => {
    const startDate = new Date(props.dataItem.start_date);
    return <td className="fw-medium">{startDate.toLocaleDateString()}</td>;
};

const DeadlineCell = (props) => {
    const deadlineDate = new Date(props.dataItem.end_date);
    const isPastDeadline = deadlineDate < new Date();
    return (
        <td>
            <div className='fw-medium' style={{ color: isPastDeadline ? '#f2426e' : 'inherit' }}>
                {deadlineDate.toLocaleDateString()}
            </div>
        </td>
    );
};

const StatusCell = (updateStatusFn) => (props) => {
    const { status, id, is_done } = props.dataItem;
    if (status === "Completed") {
        return (
            <td>
                <span className="badge gth-badge-success-light rounded-pill">{status}</span>
            </td>
        );
    }
    if ((status === "Pending" || status === "In Progress") && is_done == 1) {
        return (
            <td>
                <span className="badge rounded-pill cursor-pointer gth-badge-danger-light">
                    Under Review
                </span>
            </td>
        );
    }
    return (
        <td>
            <OverlayTrigger
                trigger="click"
                rootClose
                placement="auto"
                overlay={
                    <>{status === "Pending" && <Popover id="status-popover" className="unique-outer-wrap p-2">
                        <div className="unique-outer-wrap">
                            <div className='mb-2'>
                                <span
                                    className="badge gth-badge-info-light rounded-pill cursor-pointer"
                                    onClick={() => updateStatusFn(id, "In Progress")}
                                >
                                    In Progress
                                </span>
                            </div>
                            {/* <div className='mb-0'>
                                <span
                                    className="badge gth-badge-success-light rounded-pill cursor-pointer"
                                    onClick={() => updateStatusFn(id, "Completed")}
                                >
                                    Completed
                                </span>
                            </div> */}
                        </div>
                    </Popover>}</>

                }
            >
                <span className={`badge rounded-pill cursor-pointer ${status === "In Progress" ? "gth-badge-info-light" : "gth-badge-muted-light"
                    }`}>
                    {status}
                </span>
            </OverlayTrigger>
        </td>
    );
};

const ActionCell = (handleShowEditPTaskModal, handleShowClosePTaskModal, handleShowProjectTaskDoneModal, messageTaskVisiable, handleShowDeleteTaskModal, handleShowViewProjectTaskModal) => (props) => (
    <td>
        <div className="d-flex gap-2 align-items-center">
            <Tooltip title="Edit Task">
                <button className="table-action-btn" onClick={() => handleShowEditPTaskModal(props.dataItem)}>
                    <i className="fas fa-pen"></i>
                </button>
            </Tooltip>

            {(props.dataItem.is_closed !== 1 && props.dataItem.is_closed !== true) && (
                <Tooltip title="Close Task">
                    <button
                        className="table-action-btn"
                        onClick={() => handleShowClosePTaskModal(props.dataItem)}
                    >
                        <i className="fas fa-ban"></i>
                    </button>
                </Tooltip>
            )}
            {((props.dataItem.status == "Pending" || props.dataItem.status == "In Progress")) && (
                <Tooltip title="Done"><button className="table-action-btn" onClick={() => handleShowProjectTaskDoneModal(props.dataItem)}><i className="fas fa-check"></i></button></Tooltip>
            )}
            <Tooltip title="Remarks"><button className="table-action-btn" onClick={() =>
                messageTaskVisiable(props.dataItem.project)
            }><i className="fas fa-comment-dots"></i></button></Tooltip>
            <Tooltip title="Delete Task"><button className="table-action-btn" onClick={() => handleShowDeleteTaskModal(props.dataItem)}><i className="fas fa-trash-alt text-exp-red"></i></button></Tooltip>
            <Tooltip title="View Task">
                <button
                    className="table-action-btn"
                    onClick={() => handleShowViewProjectTaskModal(props.dataItem)}
                >
                    <i className="fas fa-eye"></i>
                </button>
            </Tooltip>
        </div>
    </td>
);

// --- Main Component ---
function ProjectTaskListDoer({
    handleShowAddPTaskModal,
    handleShowClosePTaskModal,
    handleShowProjectTaskDoneModal,
    handleShowTaskRemarksModal,
    priorityOptions
}) {
    const { User, MatchPermission } = UserAuth();
    const { id } = useParams();

    // ================== ALL HOOKS MUST BE AT THE TOP ==================
    const [taskData, setTaskData] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showCloseModal, setShowCloseModal] = useState(false);
    const [showDoneModal, setShowDoneModal] = useState(false);
    const [showViewProjectTaskModal, setShowViewProjectTaskModal] = useState(false);
    const [viewTask, setViewTask] = useState(null);
    const [messageModalVisible, setMessageModalVisible] = useState(false);
    const [messageModalData, setMessageModalData] = useState(false);

    // ================== ALL useEffect HOOKS MUST BE HERE ==================
    useEffect(() => {
        // Only fetch tasks if user has permission
        if (MatchPermission(['Add Project', 'View Project', 'Edit Project', 'Delete Project', 'Project All', 'Doer Edit Project'])) {
            fetchTasks();
        }
    }, [MatchPermission]);

    // ================== PERMISSION CHECK AFTER ALL HOOKS ==================
    // Only allow users with project permissions to access this page
    if (!MatchPermission(['Add Project', 'View Project', 'Edit Project', 'Delete Project', 'Project All', 'Doer Edit Project'])) {
        return (
            <div className="p-4 text-center">
                <h4>Access Denied</h4>
                <p>You don't have permission to view project tasks.</p>
            </div>
        );
    }

    const fetchTasks = async () => {
        try {
            const res = await PrivateAxios.get(`/projecttasks/mytasks`);
            console.log(res, 'my tasks');

            if (res.data?.success) setTaskData(res.data.tasks || []);
            else setTaskData([]);
        } catch (err) {
            console.error("Error fetching tasks:", err);
        }
    };

    const updateStatus = async (taskId, newStatus) => {
        if (!MatchPermission(['Edit Project', 'Project All', 'Doer Edit Project'])) {
            return;
        }

        try {
            const res = await PrivateAxios.put(`/projecttasks/update-status/${taskId}`, { status: newStatus });
            if (res.data?.success) {
                setTaskData(prev => prev.map(task => task.id === taskId ? { ...task, status: newStatus } : task));
                SuccessMessage("Task status updated successfully");
            }
        } catch (err) { console.error("Error updating status:", err); }
    };

    // ---- Edit Task ----
    const handleShowEditPTaskModalInternal = (task) => {
        if (!MatchPermission(['Edit Project', 'Project All', 'Doer Edit Project'])) return;
        setSelectedTask(task);
        setShowEditModal(true);
    };
    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedTask(null);
    };

    // ---- Delete Task ----
    const handleShowDeleteTaskModal = (task) => {
        if (!MatchPermission(['Delete Project', 'Project All', 'Doer Edit Project'])) return;
        setSelectedTask(task);
        setShowDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedTask(null);
    };

    // ---- Close Task ----
    const handleShowCloseModal = (task) => {
        if (!MatchPermission(['Edit Project', 'Project All', 'Doer Edit Project'])) return;
        setSelectedTask(task);
        setShowCloseModal(true);
    };
    const handleCloseCloseModal = () => {
        setShowCloseModal(false);
        setSelectedTask(null);
    };

    // ---- Done Task ----
    const handleShowDoneModal = (task) => {
        if (!MatchPermission(['Edit Project', 'Project All', 'Doer Edit Project'])) return;
        setSelectedTask(task);
        setShowDoneModal(true);
    };
    const handleCloseDoneModal = () => {
        setShowDoneModal(false);
        setSelectedTask(null);
    };

    const handleCreate = () => setShowCreateModal(true);
    const handleCloseCreateModal = () => setShowCreateModal(false);
    const exportToExcel = () => { if (excelExportRef.current) excelExportRef.current.save(); };
    const exportToPDF = () => { if (pdfExportRef.current) pdfExportRef.current.save(); };

    const handleShowViewProjectTaskModal = (task) => {
        setViewTask(task);
        setShowViewProjectTaskModal(true);
    };

    const handleCloseViewProjectTaskModal = () => {
        setShowViewProjectTaskModal(false);
        setViewTask(null);
    };

    //Message Modal Call
    const messageTaskVisiable = (data) => {
        setMessageModalData(data);
        setMessageModalVisible(true);
    };
    const messageTaskHide = () => {
        setMessageModalVisible(false);
    };
    console.log("selectedTask", showDoneModal, selectedTask)
    return (
        <div className='p-4'>
            <div className="card">
                <div className="card-body p-0">
                    <div className='d-flex justify-content-between align-items-center flex-wrap p-3'>
                        <h5 className='fs-5 my-1'>My Project Tasks</h5>
                        <div className='d-flex gap-2'>
                            {MatchPermission(['View Project', 'Project All', 'Doer Edit Project']) && (
                                <>
                                    <button className="btn btn-outline-secondary btn-sm" onClick={exportToExcel}>
                                        <i className="fas fa-file-excel me-2" /> Export Excel
                                    </button>
                                    <button className="btn btn-outline-secondary btn-sm" onClick={exportToPDF}>
                                        <i className="fas fa-file-pdf me-2" /> Export PDF
                                    </button>
                                </>
                            )}
                            {MatchPermission(['Add Project', 'Project All', 'Doer Edit Project']) && (
                                <button className="btn btn-exp-primary btn-sm fw-bold" onClick={handleCreate}>
                                    <i className="fas fa-plus me-2" /> Add Task
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Only show grid if user has view permission */}
                    {MatchPermission(['View Project', 'Project All']) ? (
                        <ExcelExport ref={excelExportRef} data={taskData} fileName="My_Project_Tasks.xlsx">
                            <PDFExport ref={pdfExportRef} paperSize="auto" fileName="My_Project_Tasks.pdf">
                                <Grid
                                    className="kendo-table-border-block rounded-10 overflow-auto"
                                    data={taskData}
                                    sortable={{ mode: 'multiple' }}
                                    pageable={{ pageSizes: [5, 10], buttonCount: 3 }}
                                    resizable
                                >
                                    <GridColumn field="id" title="ID" width="70px" cell={SerialNumberCell} />
                                    <GridColumn field="projectName" title="Project Name" width="250px" cell={ProjectNameCell} />
                                    <GridColumn field="taskName" title="Task Name" width="250px" cell={ProjectTaskNameCell} />
                                    <GridColumn
                                        field="doerName" title="Doer"
                                        width="220px"
                                        cell={(props) => DoerNameCell(props, User)}
                                    />

                                    <GridColumn field="priority" title="Priority" width="150px" cell={PriorityCell} />
                                    <GridColumn field="assignBy" title="Assign By" width="230px" cell={(props) => AssignByCell(props, User)} />
                                    <GridColumn field="startDate" title="Start Date" width="180px" cell={StartDateCell} />
                                    <GridColumn field="deadLine" title="End Date" width="180px" cell={DeadlineCell} />
                                    <GridColumn field="status" title="Status" width="150px" cell={StatusCell(updateStatus)} />
                                    <GridColumn field="action" title="Action" width="250px" cell={ActionCell(
                                        handleShowEditPTaskModalInternal,
                                        handleShowCloseModal,
                                        handleShowDoneModal,
                                        messageTaskVisiable,
                                        handleShowDeleteTaskModal,
                                        handleShowViewProjectTaskModal,
                                    )} />
                                </Grid>
                            </PDFExport>
                        </ExcelExport>
                    ) : (
                        <div className="p-4 text-center">
                            <p>You don't have permission to view project tasks.</p>
                        </div>
                    )}

                    {showEditModal && selectedTask && MatchPermission(['Edit Project', 'Project All', 'Doer Edit Project']) && (
                        <EditTaskModal
                            show={showEditModal}
                            handleClose={handleCloseEditModal}
                            task={selectedTask}
                            priorityOptions={priorityOptions}
                            onUpdated={fetchTasks}
                        />
                    )}

                    {showDeleteModal && selectedTask && MatchPermission(['Delete Project', 'Project All', 'Doer Edit Project']) && (
                        <DeleteTaskModal
                            show={showDeleteModal}
                            handleClose={handleCloseDeleteModal}
                            task={selectedTask}
                            onUpdated={fetchTasks}
                        />
                    )}

                    {showCreateModal && MatchPermission(['Add Project', 'Project All', 'Doer Edit Project']) && (
                        <CreateTaskModal
                            show={showCreateModal}
                            handleClose={handleCloseCreateModal}
                            onUpdated={fetchTasks}
                            priorityOptions={priorityOptions}
                        />
                    )}

                    {showCloseModal && selectedTask && MatchPermission(['Edit Project', 'Project All', 'Doer Edit Project']) && (
                        <CloseTaskModal
                            show={showCloseModal}
                            handleClose={handleCloseCloseModal}
                            task={selectedTask}
                            onUpdated={fetchTasks}
                        />
                    )}

                    {showDoneModal && selectedTask && MatchPermission(['Edit Project', 'Project All', 'Doer Edit Project']) && (
                        <DoneTaskModal
                            show={showDoneModal}
                            handleClose={handleCloseDoneModal}
                            taskData={selectedTask}
                            onSuccess={fetchTasks}
                        />
                    )}

                    {showViewProjectTaskModal && viewTask && MatchPermission(['View Project', 'Project All', 'Doer Edit Project']) && (
                        <ViewProjectTaskModal
                            show={showViewProjectTaskModal}
                            handleClose={handleCloseViewProjectTaskModal}
                            task={viewTask}
                        />
                    )}

                    {/* Project Message Modal */}
                    {MatchPermission(['View Project', 'Project All', 'Doer Edit Project']) && (
                        <ProjectMessage
                            show={messageModalVisible}
                            handleClose={messageTaskHide}
                            title="Message Task"
                            data={messageModalData}
                        />
                    )}

                </div>
            </div>
        </div>
    );
}

export default ProjectTaskListDoer;
